<template>
  <ClientOnly>
    <PagesBakuneCm />
  </ClientOnly>
</template>

<script setup lang="ts">
import { useCustomMeta } from "~/composables/meta"

const config = useRuntimeConfig()
const BASE_URL = config.public.BASE_URL

const customMeta = useCustomMeta()

definePageMeta({ layout: "default-with-extended-footer" })

useHead(
  customMeta.fetch({
    title: `疲労回復はパジャマから`,
    description:
      "寝ている間に、効率的に疲労を回復。疲労回復パジャマBAKUNEをはじめてみませんか？CMで櫻井さんが着用しているのは、人気のスウェットタイプ。迷ったら、一番スタンダードなスウェットタイプがおすすめです。豊富なカラーバリエーションから、あなたの好きな色を見つけて下さい。",
    image: `${BASE_URL}/images/bakune_cm/main/cm_ogp.jpeg`,
  }),
)
</script>
